/*
* 新增广告活动-投放类型
*/
<template>
  <div class="add-launch-type">
    <el-form :model="form" :rules="rules" label-width="90px">
      <el-form-item prop="targetingType" label="类型" style="margin-bottom: 0">
        <template v-for="item in radioList">
          <el-radio
            :key="item.label"
            :label="item.label"
            v-model="form.targetingType"
            >{{ item.name }}</el-radio>
          <span :key="`${item.label}msg`" class="msg">（{{ item.msg }}）</span>
        </template>
      </el-form-item>
      <!-- 关键词 -->
      <div v-if="form.targetingType == 0">
        <div style="padding-bottom: 20px;">
          <el-form-item class="base-form" prop="targetingType" label="自动竞价">
            <template #label>
              <span>自动竞价</span>
              <gj-help style="padding-left: 3px">使用自动竞价，即表示您允许亚马逊针对搜索结果顶部下方的其他广告位优化您的竞价。 您提供的定位竞价适用于搜索结果顶部，并且用作其他广告位的最大竞价起始值。 然后，根据针对其他广告位观察到的转化率，亚马逊可能会降低这些广告位的竞价。</gj-help>
            </template>
            <gj-switch v-model="form.bidOptimization" active-color="#1F6EEF" inactive-color="#ddd"></gj-switch>
          </el-form-item>
          <app-keyword-picker
              ref="keyword"
              :form="form.keywordPickerForm1"
              title="关键词"
              :params="params"
              :marketId="publicObj.SB.marketId"
              :currencySymbol="publicObj.SB.currencySymbol"
              :matchTypeOption="AdKeywordEnum.SB.matchTypeOptionNew"
              :bid="defaultBid"
              @hook:mounted="getKeywordData"
          ></app-keyword-picker>
        </div>
        <div>
          <app-neg-keyword-picker
            ref="neg-keyword"
            :form="form.keywordPickerForm2"
            title="否定关键词"
            :marketId="publicObj.SB.marketId"
            :matchTypeOption="AdNegKeywordEnum.SP.matchTypeOption"
        ></app-neg-keyword-picker>
        </div>
      </div>
      <!-- 商品投放 -->
      <div v-else-if="form.targetingType == 1">
        <div style="padding-bottom: 20px;">
          <el-form-item class="base-form" prop="targetingType" label="自动竞价">
            <template #label>
              <span>自动竞价</span>
              <gj-help style="padding-left: 3px">使用自动竞价，即表示您允许亚马逊针对搜索结果顶部下方的其他广告位优化您的竞价。 您提供的定位竞价适用于搜索结果顶部，并且用作其他广告位的最大竞价起始值。 然后，根据针对其他广告位观察到的转化率，亚马逊可能会降低这些广告位的竞价。</gj-help>
            </template>
            <gj-switch v-model="form.bidOptimization" active-color="#1F6EEF" inactive-color="#ddd"></gj-switch>
          </el-form-item>
          <app-product-target-picker
            ref="product-target"
            title="商品投放"
            bid-input
            :form="form.productTargetPickerForm"
            :marketId="publicObj.SB.marketId"
            :currencySymbol="publicObj.SB.currencySymbol"
            :params="params"
            :bid="defaultBid"
            @hook:mounted="getProductData"
        ></app-product-target-picker>
        </div>
        <div>
          <app-auto-neg-target-picker
            ref="neg-target"
            :form="form.autoTargetPickerForm"
            :marketId="publicObj.SB.marketId"
            title="否定商品"
            @hook:mounted="getNegProductBrand"
        ></app-auto-neg-target-picker>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import AppKeywordPicker from "@/views/modules/ad/sb/common/modal/add/common/keyword-picker";
import AppNegKeywordPicker from "@/views/modules/ad/sb/common/modal/add/common/neg-keyword-picker";
import AppProductTargetPicker from "@/views/modules/ad/sb/common/modal/add/common/product-target-picker";
import AppAutoNegTargetPicker from "@/views/modules/ad/sb/common/modal/add/common/auto-neg-target-picker";
import {AdGroupEnum, AdKeywordEnum, AdNegKeywordEnum} from "@/views/modules/ad/common/enum";
export default {
  components: { AppKeywordPicker , AppNegKeywordPicker , AppProductTargetPicker, AppAutoNegTargetPicker},
  name: "add-launch-type",
  inject: ['getForms', 'getOptions', 'getPublicObj'],
  data() {
    return {
      AdKeywordEnum,
      AdGroupEnum,
      AdNegKeywordEnum,
      radioList: [
        {
          label: 0,
          name: "关键词定位",
          msg: "选择有助于您的商品针对买家搜索展示的关键词",
        },
        {
          label: 1,
          name: "商品定位",
          msg: "选择待定商品、分类、品牌或者其他商品功能来定位您的广告",
        }
      ],
      addForm: {},
      params: {},
      form: {
        targetingType: 0,
        bidOptimization: true,
        keywordPickerForm1: {
          items: [],
          matchType: AdKeywordEnum.SP.matchType.EXACT,
          matchTypes: [
            AdKeywordEnum.SP.matchType.EXACT,
            AdKeywordEnum.SP.matchType.PHASE,
            AdKeywordEnum.SP.matchType.BROAD
          ],
        },
        keywordPickerForm2: {
          items: [],
          matchType: AdNegKeywordEnum.SP.matchType.NEGATIVE_EXACT
        },
        productTargetPickerForm: {
          items: [],
          bid: null
        },
        autoTargetPickerForm: {
          items: []
        }
      },
      rules: {
        targetingType: [
          { required: true, message: '请选择投放类型', trigger: ['blur', 'change']}
        ],
      },
      defaultBid: null,
    };
  },
  watch: {
    "form.targetingType": {
      handler(newVal, oldVal) {
        this.addForm.addLaunchType.targetingType = newVal
      },
      deep: true
    },
    "form.bidOptimization": {
      handler(newVal, oldVal) {
        this.addForm.addLaunchType.bidOptimization = newVal
      },
      deep: true
    },
    "addForm.creative.asins": {
      handler(newVal, oldVal) {
        // this.form.keywordPickerForm1.items = []
        // this.form.keywordPickerForm2.items = []
        // this.form.productTargetPickerForm.items = []
        // this.form.autoTargetPickerForm.items = []
        if (!newVal || !newVal.join("")) return false
        const adFormat = this.addForm.addAdvertisingFormat.adFormat
        const asins = this.addForm.creative.asins.filter(e => e) // 商品数据
        this.params = { adFormat, asins }
        // 获取数据
        if (this.form.targetingType == 0 ) {
          this.getKeywordData()
        }else {
          this.getProductData()
          this.getNegProductBrand()
        }
      },
      deep: true
    },
    "addForm.leftIndex" (data, oldData) {
      if (data == 4) {
        const adFormat = this.addForm.addAdvertisingFormat.adFormat
        const asins = this.addForm.creative.asins.filter(e => e) // 商品数据
        this.params = { adFormat, asins }
        if (!this.params.asins || !this.params.asins.join("")) return this.$gjMessage.warning("请先选择商品")
      }
    },
    "form.keywordPickerForm1.items": {
      handler(newVal, oldVal) {
        this.addForm.addLaunchType.keywords = newVal.map(e => ({
          keywordText: e.keywordText,
          bid: e.bid,
          matchType: e.matchType,
        }))
      },
      deep: true
    },
    "form.keywordPickerForm2.items": {
      handler(newVal, oldVal) {
        // do something
        this.addForm.addLaunchType.negativeKeywords = newVal.map(e => ({
          keywordText: e.keyword,
          matchType: e.matchType,
        }))
      },
      deep: true
    },
    "form.productTargetPickerForm.items": {
      handler(newVal, oldVal) {
        this.addForm.addLaunchType.targetsDTO = newVal.map(e => ({
          id: e.categoryId || null,
          asin: e.asin || null,
          brandId: e.brandId || null,
          lowPrice: e.lowPrice || null,
          maxPrice: e.maxPrice || null,
          categoryName: e.categoryName || null,
          marks: e.marks || null,
          bid: e.bid
        }))
      },
      deep: true
    },
    "form.autoTargetPickerForm.items": {
      handler(newVal, oldVal) {
        this.addForm.addLaunchType.negativeTargets = newVal.map(e => ({
          type: e.asin ? 8 : 1,
          value: e.asin ? e.asin : e.id
        }))
      },
      deep: true
    },
    "publicObj.SB.defaultBid": {
      handler(val) {
        this.defaultBid = val
      },
      immediate:true
    }
  },
  computed: {
    publicObj() {
      return this.getPublicObj()
    },
    cOptions() {
      return this.getOptions() || {
        brandEntity: [],
      }
    }
  },
  methods: {
    // 获取关键词数据
    getKeywordData() {
      if (!this.params.asins || !this.params.asins.join("")) return false
      this.$refs.keyword.suggestedBid(this.params)
    },
    // 获取商品投放数据
    getProductData() {
      if (!this.params.asins || !this.params.asins.join("")) return false
      this.$refs['product-target'].getSuggestedClassification(this.params)
      this.$refs['product-target'].getRecommendedASIN(this.params)
    },
    // 获取否定商品投放数据
    getNegProductBrand() {
      if (!this.params.asins || !this.params.asins.join("")) return false
      let brandEntity = this.cOptions.brandEntity.filter(e => e.id == this.addForm.addBase.brandEntityId)
      let keyword = (brandEntity.length != 0 && brandEntity[0].text) || null
      keyword && this.$refs['neg-target'].getProductBrand({...this.params, keyword})
    }
  },
  created() {
    this.addForm = this.getForms()
    const adFormat = this.addForm.addAdvertisingFormat.adFormat
    const asins = this.addForm.creative.asins.filter(e => e) // 商品数据
    this.params = { adFormat, asins }
    this.form.keywordPickerForm1.items = this.addForm.addLaunchType.keywords || []
    this.form.keywordPickerForm2.items = this.addForm.addLaunchType.negativeKeywords || []
    this.form.productTargetPickerForm.items = this.addForm.addLaunchType.targetsDTO || []
    this.form.autoTargetPickerForm.items = this.addForm.addLaunchType.negativeTargets || []
  }
};
</script>

<style scoped lang="scss">
.pb12 {
  padding-bottom: 12px;
}
.form-msg {
  font-size: 12px;
  color: #969696;
  display: inline-block;
  transform: scale(.95) translate(-23px, 2px);
}
/deep/.gj-picker {
  width: 1300px;
  margin-left: 90px;
}
.app-neg-keyword-picker {
  /deep/.gj-picker__editor {
    padding: 0 10px;
  }
}
/deep/.gj-picker__editor {
  width: 50% !important;
}
/deep/.base-form {
  .el-form-item__label {
    width: 90px;
    text-align: right;
  }
}
.add-launch-type {
  min-height: 300px;
  .msg {
    display: inline-block;
    color: #969696;
    font-size: 12px;
    transform: translateX(-30px);
  }
}
</style>